import { render, staticRenderFns } from "./LimitUsage.vue?vue&type=template&id=c7478588&scoped=true&lang=pug"
import script from "./LimitUsage.vue?vue&type=script&lang=js"
export * from "./LimitUsage.vue?vue&type=script&lang=js"
import style0 from "./LimitUsage.vue?vue&type=style&index=0&id=c7478588&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7478588",
  null
  
)

export default component.exports